@if (component?.elements?.length) {
  <div class="wrap"
    >
    <!-- SQUARES IN ROW VARIANT -->
    @if (component.variant === 'squares_row') {
      <div>
        <div [grid]="3"
          [gridColumnGap]="4">
          @for (item of component.elements; track item) {
            <page-component-range-squares-image class="pos-relative"
              [item]="item"
              [componentVariant]="component.variant">
            </page-component-range-squares-image>
          }
        </div>
      </div>
    }
    <!-- LARGE SQUARE VARIANTS -->
    @if (component.variant === 'large_square_right' || component.variant === 'large_square_left') {
      <div class="grid-range-squares"
        [ngClass]="component.variant"
        [grid]="3"
        [gridColumnGap]="4"
        [gridRowGap]="4"
        >
        <!-- Small squares -->
        <div class="small-square"
          [grid]="1">
          @for (item of rangeSquares() ; track item) {
            <page-component-range-squares-image class="pos-relative"
              [item]="item"
              [componentVariant]="component.variant">
            </page-component-range-squares-image>
          }
        </div>
        <!-- Large squares -->
        <div class="large-square">
          @for (item of rangeSquares(true) ; track item) {
            <page-component-range-squares-image class="pos-relative"
              [item]="item"
              [componentVariant]="component.variant">
            </page-component-range-squares-image>
          }
        </div>
      </div>
    }
  </div>
}
